/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': '完成編輯',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': '進行編輯',
  'editor-common-extensibility.macro.button.configure': '設定 {macroName}',
  'editor.extension.legacyContentHeader': '舊版內容',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': '此內容的功能有限，',
  'editor.extension.legacyContentHeader.learnMore': '深入了解',
  'editor.trackChanges.toolbarIconLabel': '追蹤變更',
  'fablric.editor.viewAllInserts': '檢視所有插入內容',
  'fabric.editor.action': '動作項目',
  'fabric.editor.action.description': '建立並指派動作項目',
  'fabric.editor.addAltText': '替代文字',
  'fabric.editor.addColumnLeft': '新增左側欄',
  'fabric.editor.addColumnRight': '新增右欄',
  'fabric.editor.addCommentOnMedia': '新增留言',
  'fabric.editor.addImageBorder': '新增邊框',
  'fabric.editor.addLoomVideo': '錄製 Loom 影片',
  'fabric.editor.addLoomVideoComment': '錄製 Loom 影片的留言',
  'fabric.editor.addMediaFiles': '新增圖片、影片或檔案',
  'fabric.editor.addRowAbove': '在上方新增列',
  'fabric.editor.addRowBelow': '在下方新增列',
  'fabric.editor.addUpdatedAltText': '新增替代文字',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription': '使用 Atlassian Intelligence 尋找交辦事項並在面板中顯示',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': '交辦事項面板 (測試版)',
  'fabric.editor.ai.ai-panels.summarizePageDescription': '使用 Atlassian Intelligence 摘要此頁面，並在面板中顯示',
  'fabric.editor.ai.ai-panels.summarizePageTitle': '頁面摘要面板 (測試版)',
  'fabric.editor.ai.ai-smart-button.context.reference': '選取的內容',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription': '產生要插入到更新中的內容',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': '總結更新內容',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': '產生',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': '詢問 Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': '編輯',
  'fabric.editor.ai.config.item.action.insert': '插入',
  'fabric.editor.ai.config.item.action.insertAtTop': '在頂端插入',
  'fabric.editor.ai.config.item.action.insertBelow': '在下方插入',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': '在原始內容下插入',
  'fabric.editor.ai.config.item.action.replace': '取代',
  'fabric.editor.ai.config.item.action.replaceTitle': '取代標題',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip': '標題不能超過 {maxLength} 個字元',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': '在聊天中繼續',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': '在聊天中開啟',
  'fabric.editor.ai.config.item.addPolish.description': '潤飾內容，讓內容更精彩',
  'fabric.editor.ai.config.item.addPolish.title': '新增潤飾',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo 客服人員',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': '縮短內容，提升簡潔度',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': '縮短更新',
  'fabric.editor.ai.config.item.bb.pr.description.description': '建立包含變更摘要的提取要求描述',
  'fabric.editor.ai.config.item.bb.pr.description.title': '建立提取要求描述',
  'fabric.editor.ai.config.item.brainstorm.description': '為您提供的主題產生構想列表',
  'fabric.editor.ai.config.item.brainstorm.promptHint': '告訴我這個主題...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': '腦力激盪',
  'fabric.editor.ai.config.item.brainstorm.title': '腦力激盪',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': '長度',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': '調整長度',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': '將內容的語調變更為休閒',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': '休閒',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': '休閒',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': '將語調變更為休閒',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': '將內容的語調變更為教學',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': '教學',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': '教學',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': '將語調變更為教學',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': '將內容的語調變更為富有同理心',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': '富有同理心',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': '富有同理心',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': '將語調變更為富有同理心',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': '將語調變更為...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': '將內容的語調變更為中性',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': '中性',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': '中性',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': '將語調變更為中性',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': '將內容的語調變更為專業',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': '專業',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': '專業',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': '將語調變更為專業',
  'fabric.editor.ai.config.item.convertToBulletList.description': '將內容重新調整為項目符號清單',
  'fabric.editor.ai.config.item.convertToBulletList.title': '轉換為項目符號清單',
  'fabric.editor.ai.config.item.convertToTable.description': '將內容重新調整為包含標題的表格',
  'fabric.editor.ai.config.item.convertToTable.title': '轉換為表格',
  'fabric.editor.ai.config.item.draftReply.description': '根據您正在處理的類似議題草擬回覆',
  'fabric.editor.ai.config.item.draftReply.title': '草擬回覆',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': '修正拼寫和文法錯誤',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': '拼字與文法',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': '修正拼字與文法',
  'fabric.editor.ai.config.item.enhance.improveWriting.description': '提升清晰度、結構和語調，以增進參與和理解',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': '改善寫作',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': '改善寫作',
  'fabric.editor.ai.config.item.findActionItems.description': '在您提供的內容中尋找交辦事項',
  'fabric.editor.ai.config.item.findActionItems.title': '尋找交辦事項',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint': '從下方選取 (自由生成目前已在 Elevate 中停用)',
  'fabric.editor.ai.config.item.generateContent.promptHint': '透過 AI 撰寫或從下方選取',
  'fabric.editor.ai.config.item.generateEscalationNotes.description': '根據議題背景資訊產生向上呈報附註',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': '產生向上呈報附註',
  'fabric.editor.ai.config.item.improveDescription.default.description': '根據議題類型重新建構議題描述',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': '改善描述',
  'fabric.editor.ai.config.item.makeLonger.description': '根據您提供的背景資訊展開內容',
  'fabric.editor.ai.config.item.makeLonger.title': '增加長度',
  'fabric.editor.ai.config.item.range.agent.description': '沒有描述',
  'fabric.editor.ai.config.item.range.agent.prompt.hint': '請客服人員撰寫任何內容或從下方選擇',
  'fabric.editor.ai.config.item.rephrase.description': '提出重新撰寫句子的建議',
  'fabric.editor.ai.config.item.rephrase.title': '換個方式描述',
  'fabric.editor.ai.config.item.shorten.description': '縮短內容，提升簡潔度',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': '縮短',
  'fabric.editor.ai.config.item.shorten.title': '縮短',
  'fabric.editor.ai.config.item.suggest.description': '為您提供的內容建議標題',
  'fabric.editor.ai.config.item.suggest.title': '建議標題',
  'fabric.editor.ai.config.item.summarize.description': '針對您正在處理的文字建立摘要，突顯重點',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': '摘要寫作',
  'fabric.editor.ai.config.item.summarize.title': '摘要寫作',
  'fabric.editor.ai.config.item.translate.czech': '捷克文',
  'fabric.editor.ai.config.item.translate.danish': '丹麥文',
  'fabric.editor.ai.config.item.translate.dutch': '荷蘭文',
  'fabric.editor.ai.config.item.translate.english': '英文',
  'fabric.editor.ai.config.item.translate.finnish': '芬蘭文',
  'fabric.editor.ai.config.item.translate.french': '法文',
  'fabric.editor.ai.config.item.translate.german': '德文',
  'fabric.editor.ai.config.item.translate.hungarian': '匈牙利文',
  'fabric.editor.ai.config.item.translate.italian': '義大利文',
  'fabric.editor.ai.config.item.translate.japanese': '日文',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': '翻譯',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': '翻譯成...',
  'fabric.editor.ai.config.item.translate.norwegian': '挪威文',
  'fabric.editor.ai.config.item.translate.russian': '俄文',
  'fabric.editor.ai.config.item.translate.spanish': '西班牙文',
  'fabric.editor.ai.config.item.translate.swedish': '瑞典文',
  'fabric.editor.ai.config.item.translate.thai': '泰語',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description': '將您正在處理的文字翻譯成中文 (簡體)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': '翻譯成中文 (簡體)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description': '將您正在處理的文字翻譯成中文 (繁體)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': '翻譯成中文 (繁體)',
  'fabric.editor.ai.config.item.translateTo.czech.description': '將您正在處理的文字翻譯成捷克文',
  'fabric.editor.ai.config.item.translateTo.czech.title': '翻譯成捷克文',
  'fabric.editor.ai.config.item.translateTo.danish.description': '將您正在處理的文字翻譯成丹麥文',
  'fabric.editor.ai.config.item.translateTo.danish.title': '翻譯成丹麥文',
  'fabric.editor.ai.config.item.translateTo.dutch.description': '將您正在處理的文字翻譯成荷蘭文',
  'fabric.editor.ai.config.item.translateTo.dutch.title': '翻譯成荷蘭文',
  'fabric.editor.ai.config.item.translateTo.english.description': '將您正在處理的文字翻譯成英文',
  'fabric.editor.ai.config.item.translateTo.english.title': '翻譯成英文',
  'fabric.editor.ai.config.item.translateTo.finnish.description': '將您正在處理的文字翻譯成芬蘭文',
  'fabric.editor.ai.config.item.translateTo.finnish.title': '翻譯成芬蘭文',
  'fabric.editor.ai.config.item.translateTo.french.description': '將您正在處理的文字翻譯成法文',
  'fabric.editor.ai.config.item.translateTo.french.title': '翻譯成法文',
  'fabric.editor.ai.config.item.translateTo.german.description': '將您正在處理的文字翻譯成德文',
  'fabric.editor.ai.config.item.translateTo.german.title': '翻譯成德文',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': '將您正在處理的文字翻譯成匈牙利文',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': '翻譯成匈牙利文',
  'fabric.editor.ai.config.item.translateTo.italian.description': '將您正在處理的文字翻譯成義大利文',
  'fabric.editor.ai.config.item.translateTo.italian.title': '翻譯成義大利文',
  'fabric.editor.ai.config.item.translateTo.japanese.description': '將您正在處理的文字翻譯成日文',
  'fabric.editor.ai.config.item.translateTo.japanese.title': '翻譯成日文',
  'fabric.editor.ai.config.item.translateTo.korean.description': '將您正在處理的文字翻譯成韓文',
  'fabric.editor.ai.config.item.translateTo.korean.title': '翻譯成韓文',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': '將您正在處理的文字翻譯成挪威文',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': '翻譯成挪威文',
  'fabric.editor.ai.config.item.translateTo.polish.description': '將您正在處理的文字翻譯成波蘭文',
  'fabric.editor.ai.config.item.translateTo.polish.title': '翻譯成波蘭文',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description': '將您正在處理的文字翻譯成葡萄牙文 (巴西)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': '翻譯成葡萄牙文 (巴西)',
  'fabric.editor.ai.config.item.translateTo.russian.description': '將您正在處理的文字翻譯成俄文',
  'fabric.editor.ai.config.item.translateTo.russian.title': '翻譯成俄文',
  'fabric.editor.ai.config.item.translateTo.spanish.description': '將您正在處理的文字翻譯成西班牙文',
  'fabric.editor.ai.config.item.translateTo.spanish.title': '翻譯成西班牙文',
  'fabric.editor.ai.config.item.translateTo.swedish.description': '將您正在處理的文字翻譯成瑞典文',
  'fabric.editor.ai.config.item.translateTo.swedish.title': '翻譯成瑞典文',
  'fabric.editor.ai.config.item.translateTo.thai.description': '將您正在處理的文字翻譯成泰文',
  'fabric.editor.ai.config.item.translateTo.thai.title': '翻譯成泰文',
  'fabric.editor.ai.config.item.translateTo.turkish.description': '將您正在處理的文字翻譯成土耳其文',
  'fabric.editor.ai.config.item.translateTo.turkish.title': '翻譯成土耳其文',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description': '將您正在處理的文字翻譯成烏克蘭文',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': '翻譯成烏克蘭文',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description': '將您正在處理的文字翻譯成越南文',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': '翻譯成越南文',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': '改變語調',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': '重寫',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': '翻譯',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': '頁面標題',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': '頁面',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    '我們遇到問題，現在無法產生回應。請稍後再試一次。',
  'fabric.editor.ai.experience-application.documentInsertError':
    '我們在插入回應時遇到問題。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    '我們無法產生預覽。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    '我們近期收到過多 Atlassian Intelligence (AI) 要求。請在幾分鐘後再試一次，或參閱 <link>AI 使用過量</link>。',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    '我們無法取得回應。您的提示或回應已超過此要求的限制。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.experience-application.unhandledErrorMessage': '我們遇到問題。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.experience.adfStreamingError': '很抱歉，我們無法取得回應。',
  'fabric.editor.ai.experience.apiError': '我們無法收到回覆，請再試一次。',
  'fabric.editor.ai.experience.aupViolationMessage':
    '您的提示或內容可能不符合我們的《可接受使用政策》。請檢閱提示和內容，並視需要參閱我們的<link>《可接受使用政策》</link>。如果問題仍然存在，請考慮嘗試不同的提示或內容。',
  'fabric.editor.ai.experience.browseMore.agents': '瀏覽客服人員',
  'fabric.editor.ai.experience.cmdPaletteApiError': '產生您的回應時發生錯誤。',
  'fabric.editor.ai.experience.cmdPaletteAupViolationMessage':
    '我們無法完成該要求，因為它不符合我們的<link>可接受使用政策</link>。',
  'fabric.editor.ai.experience.discardMessagePrompt': '您要捨棄提示嗎？',
  'fabric.editor.ai.experience.discardMessageResponse': '您要捨棄回覆嗎？',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': '要取消要求並捨棄回應嗎？',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': '自由生成目前已在 Elevate 中停用。',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 您現在可以在提示中貼上 Jira 和 Confluence 內容的連結 🔗。',
  'fabric.editor.ai.experience.footerRightText.agents': '由 Rovo 提供技術支援',
  'fabric.editor.ai.experience.generatingAiResponse': '正在產生',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence 無法處理您的要求，因為您的內容包含 HIPAA 受限內容的連結。請移除這些連結，然後再試一次。',
  'fabric.editor.ai.experience.inputTooShortError': '內容太短，無法總結。請新增更多內容並再試一次。',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) 沒有回應。請稍後再試一次，或<link>檢查 AI 的狀態</link>。',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': '正在產生',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': '正在分析：正在檢閱您的問題。',
  'fabric.editor.ai.experience.messageTemplateContentSearch': '正在搜尋：請稍候，我們正在搜尋資訊。',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': '正在搜尋：請稍候，我們正在搜尋 Jira。',
  'fabric.editor.ai.experience.messageTemplatePageHydration': '正在搜尋：請稍候，我們正在搜尋頁面。',
  'fabric.editor.ai.experience.noResultsSuggestion': '沒有結果',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence 目前沒有建議。歡迎嘗試不同的提示或內容。',
  'fabric.editor.ai.experience.showMoreButton': '顯示更多',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': '動作',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': '客服人員',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': '知識來源',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo 客服人員',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo 客服人員 ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': '使用 Rovo 客服人員 ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': '使用一般知識',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': '使用組織的知識',
  'fabric.editor.ai.proactive.error.markdownErrorMessage': '我們無法產生預覽。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage': '我們遇到問題。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': '在下方插入',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': '取代',
  'fabric.editor.ai.screens.preview.convoAIBeta': '參考 URL 的內容產生要求正處於測試階段。',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': '突顯術語、縮寫或簡稱',
  'fabric.editor.ai.selectionToolbar.define.title': '定義',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': '定義',
  'fabric.editor.ai.toolbar.askAI.title': '詢問 Atlassian Intelligence',
  'fabric.editor.ai.toolbar.askRovo.title': '詢問 Rovo',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "詢問 Rovo {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': '詢問 Rovo AI',
  'fabric.editor.ai.toolbar.changeTone.title': '改變語調',
  'fabric.editor.ai.toolbar.changeToneOptions.title': '變更音調選項',
  'fabric.editor.ai.toolbar.improveWriting.title': '改善寫作',
  'fabric.editor.ai.toolbar.improveWriting.tooltip': '告訴 Atlassian Intelligence 如何改善您選取的寫作範圍',
  'fabric.editor.ai.toolbar.makeLonger.title': '增加長度',
  'fabric.editor.ai.toolbar.makeShorter.title': '縮短',
  'fabric.editor.ai.toolbar.moreCasualTone.title': '更休閒',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': '更富有同理心',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': '更專業',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': '更多 Rovo 選項',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': '修正拼字與文法',
  'fabric.editor.ai.toolbar.summarize.title': '摘要',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': '翻譯',
  'fabric.editor.ai.toolbar.translateOptions.label': '翻譯選項',
  'fabric.editor.ai.toolbar.tryAI.title': '試用 AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': '開啟 Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "詢問 Atlassian Intellgience {key}+'",
  'fabric.editor.alignCenter': '置中對齊',
  'fabric.editor.alignImageCenter': '置中對齊',
  'fabric.editor.alignImageLeft': '靠左對齊',
  'fabric.editor.alignImageRight': '靠右對齊',
  'fabric.editor.alignLeft': '靠左對齊',
  'fabric.editor.alignRight': '靠右對齊',
  'fabric.editor.alignTableCenter': '置中對齊',
  'fabric.editor.alignTableLeft': '靠左對齊',
  'fabric.editor.alignment': '文字對齊',
  'fabric.editor.altText': '替代文字',
  'fabric.editor.alttext.validation': '請移除替代文字中的所有特殊字元。',
  'fabric.editor.annotationToolbar': '註解工具列',
  'fabric.editor.backLink': '返回',
  'fabric.editor.backgroundColor': '背景顏色',
  'fabric.editor.block.menu.codeblock': '程式碼區塊',
  'fabric.editor.block.menu.copy.block': '複製區塊',
  'fabric.editor.block.menu.copy.link': '複製連結',
  'fabric.editor.block.menu.delete.block': '刪除',
  'fabric.editor.block.menu.layout': '版面配置',
  'fabric.editor.block.menu.move.down': '向下移動',
  'fabric.editor.block.menu.move.up': '向上移動',
  'fabric.editor.block.menu.paragraph': '段落',
  'fabric.editor.blockCardUnavailable': '內嵌連結位於 {node} 內，無法變更其檢視',
  'fabric.editor.blockControlDelete': '刪除',
  'fabric.editor.blockControlDragHandleMove': '拖曳即可移動',
  'fabric.editor.blockControlDragHandleRearrange': '拖曳以重新排列',
  'fabric.editor.blockControlInsert': '插入',
  'fabric.editor.blockControlMoveDown': '向下移動',
  'fabric.editor.blockControlMoveLeft': '向左移動',
  'fabric.editor.blockControlMoveRight': '向右移動',
  'fabric.editor.blockControlMoveUp': '向上移動',
  'fabric.editor.blockControlMovedDown': '內容已向下移動',
  'fabric.editor.blockControlMovedUp': '內容已向上移動',
  'fabric.editor.blockDescription': '顯示有關連結的更多資訊，包括摘要和動作',
  'fabric.editor.blockTitle': '卡片',
  'fabric.editor.blockquote': '引述',
  'fabric.editor.blockquote.description': '插入引述或引文',
  'fabric.editor.blockquote2': '引述',
  'fabric.editor.bold': '粗體',
  'fabric.editor.breakout.resizeCodeBlock': '調整程式碼片段的大小',
  'fabric.editor.breakout.resizeElement': '調整元素大小',
  'fabric.editor.breakout.resizeExpand': '調整展開大小',
  'fabric.editor.breakout.resizeLayout': '調整版面配置的大小',
  'fabric.editor.breakoutFullWidthLabel': '全寬',
  'fabric.editor.breakoutWideWidthLabel': '寬',
  'fabric.editor.bug': '錯誤',
  'fabric.editor.bulletedList': '項目符號清單',
  'fabric.editor.canNotSortTable': '⚠️ 您無法排序包含合併儲存格的表格',
  'fabric.editor.cancelButton': '取消',
  'fabric.editor.captionPlaceholder': '新增標題',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': '新增標題 - 按兩下即可預覽',
  'fabric.editor.cardFloatingControls': '卡片選項',
  'fabric.editor.cellBackground': '儲存格背景',
  'fabric.editor.cellOptions': '儲存格選項',
  'fabric.editor.checkUncheckActionItem': '切換交辦事項',
  'fabric.editor.clearAltTextEdit': '清除替代文字',
  'fabric.editor.clearCells': '{0, plural, other {清除儲存格}}',
  'fabric.editor.clearFormatting': '清除格式設定',
  'fabric.editor.clearLink': '清除連結',
  'fabric.editor.clearLinkText': '清除文字',
  'fabric.editor.closeAltTextEdit': '返回',
  'fabric.editor.closeFindReplaceDialog': '關閉',
  'fabric.editor.closeHelpDialog': '關閉說明對話方塊',
  'fabric.editor.code': '程式碼',
  'fabric.editor.code.on': '{textFormattingOff}，程式碼開啟',
  'fabric.editor.codeBidiWarningLabel': '雙向字元會變更文字呈現的順序。這可用來將惡意程式碼模糊化。',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': '已複製！',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': '複製文字',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': '關閉圍繞',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': '開啟圍繞',
  'fabric.editor.codeblock': '程式碼片段',
  'fabric.editor.codeblock.description': '顯示程式碼並醒目提示語法',
  'fabric.editor.collapseNode': '摺疊內容',
  'fabric.editor.collapseTable': '摺疊表格',
  'fabric.editor.colorPicker.menuLabel': '顏色選擇器選單',
  'fabric.editor.columnDragHandle': '欄選項',
  'fabric.editor.columnMovedLeft': '直欄已左移至第 {index} 欄，總共有 {total} 欄',
  'fabric.editor.columnMovedRight': '直欄已右移至第 {index} 欄，總共有 {total} 欄',
  'fabric.editor.columnSelected': '已選取第 {index} 欄，總共有 {total} 欄',
  'fabric.editor.columns': '版面配置',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, other {插入 {numberOfColumns} 個相等的欄}}',
  'fabric.editor.columns.advanced.layout.single.description': '插入單一欄版面配置',
  'fabric.editor.columns.description': '使用區段建立頁面的結構',
  'fabric.editor.columnsAreInserted': '{count, plural, other {已插入 {count} 欄}}',
  'fabric.editor.columnsAreRemoved': '{count, plural, other {已移除 {count} 欄}}',
  'fabric.editor.configFailedToLoad': '無法載入',
  'fabric.editor.configPanel.cancel': '取消',
  'fabric.editor.configPanel.close': '關閉',
  'fabric.editor.configPanel.customSelect.createOption': '建立',
  'fabric.editor.configPanel.dateRange.custom.from': '從',
  'fabric.editor.configPanel.dateRange.custom.to': '至',
  'fabric.editor.configPanel.dateRange.grouping.collapse': '摺疊',
  'fabric.editor.configPanel.dateRange.grouping.expand': '展開',
  'fabric.editor.configPanel.dateRange.option.custom': '自訂',
  'fabric.editor.configPanel.documentation': '說明文件',
  'fabric.editor.configPanel.errorBoundary.note':
    '我們已經通知團隊。您仍然可以編輯和發布此頁面，或查看錯誤主控台以取得更多資訊。',
  'fabric.editor.configPanel.errorBoundary.title': '發生錯誤。',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': '無法結合 isMultiple 與 radio 風格',
  'fabric.editor.configPanel.formType.addField': '新增欄位',
  'fabric.editor.configPanel.formType.removeField': '移除欄位',
  'fabric.editor.configPanel.help': '需要協助嗎？',
  'fabric.editor.configPanel.invalid': '無效欄位',
  'fabric.editor.configPanel.required': '必要欄位',
  'fabric.editor.configPanel.submit': '提交',
  'fabric.editor.contextPanel.panelLabel': '背景資訊面板',
  'fabric.editor.copiedToClipboard': '已複製！',
  'fabric.editor.copyToClipboard': '複製',
  'fabric.editor.cornerControl': '醒目提示表格',
  'fabric.editor.createComment': '留言',
  'fabric.editor.createCommentDisabled': '您只能在文字、標題、表情符號、日期、提及、連結和狀態上留言。',
  'fabric.editor.createCommentInvalid': '您只能在文字和標題上留言',
  'fabric.editor.customPanel': '自訂面板',
  'fabric.editor.customPanel.description': '新增一個帶有表情符號和彩色背景的附註',
  'fabric.editor.datasource.assetsObjects.description':
    '透過搜尋和篩選，從 Jira Service Management 中的 Assets 插入物件',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Assets',
  'fabric.editor.datasource.confluenceSearch': '插入 Confluence 列表',
  'fabric.editor.datasource.confluenceSearch.description': '插入 Confluence 搜尋結果列表，包含增強的搜尋、篩選和組態。',
  'fabric.editor.datasource.jiraIssue': 'Jira 議題',
  'fabric.editor.datasource.jiraIssue.description': '透過增強的搜尋、篩選和組態，從 Jira Cloud 插入 Jira 議題。',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    '透過增強的搜尋、篩選和組態，從 Jira Cloud 插入 Jira 工作項目。',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira 工作項目',
  'fabric.editor.datasourceAppearanceTitle': '列表',
  'fabric.editor.datasourceTitle': '編輯搜尋查詢',
  'fabric.editor.date': '日期',
  'fabric.editor.date.description': '使用日曆新增日期',
  'fabric.editor.datePickerOpenedAlert': '日期編輯器快顯視窗已開啟，按 Tab 即可前往快顯視窗',
  'fabric.editor.decision': '決定',
  'fabric.editor.decision.description': '擷取決定以便追蹤',
  'fabric.editor.decisionPlaceholder': '新增決定…',
  'fabric.editor.decreaseElementSize': '縮小元素大小',
  'fabric.editor.decreaseSize': '縮小表格或媒體大小',
  'fabric.editor.defaultAltText': '文件',
  'fabric.editor.delete': '刪除',
  'fabric.editor.description': '描述',
  'fabric.editor.displayBlock': '顯示卡片',
  'fabric.editor.displayEmbed': '顯示嵌入',
  'fabric.editor.displayInline': '顯示內嵌',
  'fabric.editor.displayLink': '以文字顯示',
  'fabric.editor.displayOptionUnavailableInParentNode': '{node} 內無法使用此顯示選項',
  'fabric.editor.displayText': '要顯示的文字',
  'fabric.editor.distributeColumns': '平均分配直欄寬度',
  'fabric.editor.dragHandleZone': '啟用拖曳控制區',
  'fabric.editor.dropPlaceholderLabel': '文件',
  'fabric.editor.ecombedDescription': '顯示連結的互動式預覽',
  'fabric.editor.edit': '編輯',
  'fabric.editor.edit.datasource': '編輯搜尋查詢',
  'fabric.editor.edit.searchInput': '新增連結',
  'fabric.editor.editAccessTitle': '您需要編輯權限',
  'fabric.editor.editAltText': '編輯替代文字',
  'fabric.editor.editDatasourceStandalone': '編輯',
  'fabric.editor.editDatasourceStandaloneTooltip': '編輯搜尋查詢',
  'fabric.editor.editDateText': '編輯日期',
  'fabric.editor.editDropdownEditDatasourceTitle': '編輯搜尋查詢',
  'fabric.editor.editDropdownEditLinkTitle': '編輯連結',
  'fabric.editor.editDropdownExpandIconLabel': '展開下拉式選單',
  'fabric.editor.editDropdownTriggerTitle': '編輯',
  'fabric.editor.editLink': '編輯連結',
  'fabric.editor.editMode.inviteToEditButton.title': '邀請編輯',
  'fabric.editor.editStatusColor': '編輯狀態顏色',
  'fabric.editor.editStatusText': '編輯狀態',
  'fabric.editor.editableContentLabel': '可編輯內容',
  'fabric.editor.editorHelp': '編輯器說明',
  'fabric.editor.editors': '編輯者',
  'fabric.editor.elementBrowser.help': '說明',
  'fabric.editor.elementInsertSidePanel.title': '插入',
  'fabric.editor.elementbrowser.categorylist.category-admin': '管理',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': '全部',
  'fabric.editor.elementbrowser.categorylist.category-communication': '通訊',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence 內容',
  'fabric.editor.elementbrowser.categorylist.category-development': '開發',
  'fabric.editor.elementbrowser.categorylist.category-external-content': '外部內容',
  'fabric.editor.elementbrowser.categorylist.category-formatting': '格式設定',
  'fabric.editor.elementbrowser.categorylist.category-media': '媒體',
  'fabric.editor.elementbrowser.categorylist.category-navigation': '導覽',
  'fabric.editor.elementbrowser.categorylist.category-reporting': '建立報告',
  'fabric.editor.elementbrowser.categorylist.category-visuals': '視覺與影像',
  'fabric.editor.elementbrowser.featured.whiteboard.description': '使用白板，將視覺效果新增至頁面',
  'fabric.editor.elementbrowser.search.empty-state.heading': '沒有任何項目符合您的搜尋內容',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    '請試著使用不同的詞彙搜尋，或探索 Atlassian 產品的新應用程式。',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': '探索 Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {沒有任何項目符合您的搜尋內容。} other {依預設有 {count} 個適用的建議。}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {沒有任何項目符合您的搜尋內容。} other {適用於輸入文字的 {count} 個建議。}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Enter',
  'fabric.editor.elementbrowser.searchbar.placeholder': '搜尋',
  'fabric.editor.elementbrowser.sidebar.heading': '瀏覽',
  'fabric.editor.embedTitle': '嵌入',
  'fabric.editor.embedToBlockCardWarning': '在較小的畫面上顯示為卡片',
  'fabric.editor.emoji': '表情符號',
  'fabric.editor.emoji.description': '使用表情符號來傳達想法 🎉 和情緒 😄',
  'fabric.editor.emptyLink': '請輸入連結。',
  'fabric.editor.emptySearchResults': '我們找不到任何結果。',
  'fabric.editor.emptySearchResultsSuggestion': '請選取 {buttonName} 以瀏覽插入內容。',
  'fabric.editor.epic': '大型工作',
  'fabric.editor.error': '錯誤',
  'fabric.editor.errorPanel': '錯誤面板',
  'fabric.editor.errorPanel.description': '以彩色面板呼叫錯誤',
  'fabric.editor.expand': '擴充',
  'fabric.editor.expand.description': '插入擴充',
  'fabric.editor.expandAriaLabel': '為此展開節點設定標題',
  'fabric.editor.expandDefaultTitle': '按一下此處以展開...',
  'fabric.editor.expandNode': '展開內容',
  'fabric.editor.expandPlaceholder': '為此展開設定標題...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage': '刪除 {nodeName} 將中斷與其連結的任何內容。',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': '正在刪除',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': '刪除',
  'fabric.editor.extension.deleteElementTitle': '刪除元素',
  'fabric.editor.extension.sourceNoTitledName': '這個元素',
  'fabric.editor.extensions.config-panel.save-indicator': '系統會隨時自動儲存所有變更',
  'fabric.editor.externalExtensionsHeading': '應用程式',
  'fabric.editor.externalMediaFile': '外部媒體檔案',
  'fabric.editor.failed_to_upload': '無法上傳',
  'fabric.editor.feedbackDialog': '提供意見回饋',
  'fabric.editor.feedbackDialog.description': '告訴我們您的雲端編輯器使用經驗',
  'fabric.editor.find': '尋找',
  'fabric.editor.findNext': '尋找下一個',
  'fabric.editor.findPrevious': '尋找上一個',
  'fabric.editor.findReplaceToolbarButton': '尋找與取代',
  'fabric.editor.fiveColumns': '5 欄版面配置',
  'fabric.editor.floatingToolbar.confirmModalCancel': '取消',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': '同時刪除已連結的元素',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} other {{name} (+{amount,number} 個連結的元素)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': '您確定嗎？',
  'fabric.editor.floatingToolbar.confirmModalOK': '確定',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': '已開啟浮動工具列控制項',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': '浮動工具列',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': '版面配置選項',
  'fabric.editor.floatingToolbar.scrollLeft': '向左捲動',
  'fabric.editor.floatingToolbar.scrollRight': '向右捲動',
  'fabric.editor.focusTableResizeHandle': '聚焦於表格調整大小控點',
  'fabric.editor.fourColumns': '4 欄版面配置',
  'fabric.editor.headerColumn': '標題欄',
  'fabric.editor.headerRow': '標題列',
  'fabric.editor.heading1': '標題 1',
  'fabric.editor.heading1Description': '用於最高層級的標題',
  'fabric.editor.heading2': '標題 2',
  'fabric.editor.heading2Description': '用於主要區段',
  'fabric.editor.heading3': '標題 3',
  'fabric.editor.heading3Description': '用於子區段和群組標題',
  'fabric.editor.heading4': '標題 4',
  'fabric.editor.heading4Description': '用於多層標題',
  'fabric.editor.heading5': '標題 5',
  'fabric.editor.heading5Description': '用於分組清單項目',
  'fabric.editor.heading6': '標題 6',
  'fabric.editor.heading6Description': '用於低層級標題',
  'fabric.editor.headingLink.ascOrderLabel': '從 Z 欄排序到 A 欄',
  'fabric.editor.headingLink.descOrderLabel': '清除排序',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': '部落格',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': '錯誤',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': '問題',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': '工作項目',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': '頁面',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': '故事',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': '任務',
  'fabric.editor.headingLink.invalidLabel': '⚠️ 您無法排序包含合併儲存格的表格',
  'fabric.editor.headingLink.noOrderLabel': '從 A 欄排序到 Z 欄',
  'fabric.editor.help': '說明',
  'fabric.editor.help.description': '瀏覽所有鍵盤快速鍵和 Markdown 選項',
  'fabric.editor.helpDialogTips': '您可以隨時按下 {keyMap} 來快速開啟此對話方塊',
  'fabric.editor.highlight': '醒目提示顏色',
  'fabric.editor.highlight.removeColor': '移除顏色',
  'fabric.editor.highlightColor': '切換醒目提示調色盤',
  'fabric.editor.highlightFloatingToolbar': '醒目提示',
  'fabric.editor.horizontalRule': '分隔線',
  'fabric.editor.horizontalRule.description': '使用水平線來區隔內容',
  'fabric.editor.hyperlink.linkVisibleLabel': '貼上或搜尋連結',
  'fabric.editor.hyperlink.searchLinkAriaDescription': '當您在欄位中輸入內容時，建議會顯示在下方',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {沒有找到任何結果} other {找到 {count,number} 個結果}}',
  'fabric.editor.hyperlink.textVisibleLabel': '顯示文字 (選擇性)',
  'fabric.editor.hyperlinkToolbarPlaceholder': '貼上或搜尋連結',
  'fabric.editor.image': '影像',
  'fabric.editor.image.fullWidthLabel': '全寬',
  'fabric.editor.imageBorderBold': '粗體',
  'fabric.editor.imageBorderColor': '顏色',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': '圖片邊框選項顏色下拉式選單',
  'fabric.editor.imageBorderMedium': '中等',
  'fabric.editor.imageBorderOptions': '邊框選項',
  'fabric.editor.imageBorderSize': '大小',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': '影像邊框選項大小下拉式選單',
  'fabric.editor.imageBorderSubtle': '不明顯的',
  'fabric.editor.improvement': '改善',
  'fabric.editor.increaseElementSize': '放大元素大小',
  'fabric.editor.increaseSize': '增加表格或媒體大小',
  'fabric.editor.indent': '增加縮排',
  'fabric.editor.info': '資訊',
  'fabric.editor.infoPanel': '資訊面板',
  'fabric.editor.infoPanel.description': '以彩色面板醒目提示資訊',
  'fabric.editor.inlineConfigureLink': '設定連結',
  'fabric.editor.inlineDescription': '將連結顯示為內嵌文字',
  'fabric.editor.inlineGoToLink': '前往連結',
  'fabric.editor.inlineOverlay': '設定',
  'fabric.editor.inlineTitle': '內嵌',
  'fabric.editor.inputQueryAssistiveTxt':
    '自動完成結果可用時，請使用向上和向下箭頭查看，並輸入以進行選取。若您使用觸控螢幕裝置，請透過觸控或滑動手勢探索內容。',
  'fabric.editor.insertColumn': '在右側插入直欄',
  'fabric.editor.insertColumnDrag': '插入直欄',
  'fabric.editor.insertMenu': '插入元素',
  'fabric.editor.insertRightRail.close': '關閉',
  'fabric.editor.insertRightRail.title': '插入',
  'fabric.editor.insertRow': '在下方插入列',
  'fabric.editor.insertRowDrag': '插入列',
  'fabric.editor.insertTableColumn': '插入表格欄',
  'fabric.editor.insertTableRow': '插入表格列',
  'fabric.editor.invalidDateError': '請輸入有效的日期',
  'fabric.editor.invalidLink': '請輸入有效的連結。',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {邀請團隊成員加入 {productName}} trusted {邀請團隊成員加入 {productName}} other {將團隊成員新增至 {productName}}}',
  'fabric.editor.italic': '斜體',
  'fabric.editor.keyboardShortcuts': '鍵盤快速鍵',
  'fabric.editor.layout.columnOption': '{count, plural, other {{count} 欄}}',
  'fabric.editor.layout.controls.placeholder': '輸入 / 即可插入內容',
  'fabric.editor.layout.placeholder': '新增內容',
  'fabric.editor.layout.resizeLayout': '重新調整版面配置的大小',
  'fabric.editor.layoutFixedWidth': '返回中央',
  'fabric.editor.layoutFullWidth': '採用完整寬度',
  'fabric.editor.layoutStateFixedWidth': '置中',
  'fabric.editor.layoutStateFullWidth': '全寬',
  'fabric.editor.layoutStateWide': '寬',
  'fabric.editor.layoutWide': '採用寬版',
  'fabric.editor.leftSidebar': '左側邊欄版面配置',
  'fabric.editor.link': '連結',
  'fabric.editor.link.description': '插入連結',
  'fabric.editor.linkAddress': '連結位址',
  'fabric.editor.linkPlaceholder': '貼上連結',
  'fabric.editor.lists': '清單',
  'fabric.editor.listsFormat': '列表格式設定',
  'fabric.editor.lockColumns': '固定欄寬',
  'fabric.editor.longEmptyNodePlaceholderText': '輸入 / 以插入元素',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': '大小寫須相符',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, other {媒體寬度已降低至 {newMediaWidth,number} 像素。}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, other {媒體寬度已提升至 {newMediaWidth,number} 像素。}}',
  'fabric.editor.media.MediaWidthIsMin': '媒體已縮減至最小',
  'fabric.editor.media.insert.cancel': '取消',
  'fabric.editor.media.insert.fileTabTitle': '檔案',
  'fabric.editor.media.insert.fromUrlErrorMessage': '很抱歉，我們無法新增此圖片連結。請下載圖片，然後拖放到頁面上。',
  'fabric.editor.media.insert.fromUrlWarning': '由於來源限制，其他人可能無法看到此圖片。您可以考慮改為上傳檔案。',
  'fabric.editor.media.insert.insert': '插入',
  'fabric.editor.media.insert.invalidUrlErrorMessage': '無效的連結',
  'fabric.editor.media.insert.linkTabTitle': '連結',
  'fabric.editor.media.insert.loadPreview': '載入預覽',
  'fabric.editor.media.insert.localFileErrorMessage': '無法上傳此檔案。',
  'fabric.editor.media.insert.localFileNetworkErrorMessage': '檔案上傳錯誤。請檢查檔案路徑或網路。',
  'fabric.editor.media.insert.mediaAlt': '上傳的圖片或影片檔案預覽',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': '媒體選擇器',
  'fabric.editor.media.insert.pasteLinkToUpload': '貼上連結以上傳',
  'fabric.editor.media.insert.upload': '上傳',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': '媒體已增加至最大',
  'fabric.editor.media.pixelEntry.ResizeOption': '調整大小',
  'fabric.editor.media.pixelEntry.closePixelEntry': '關閉',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': '高度輸入',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': '高度',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': '最大寬度 {maxWidth}px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': '寬度',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': '最大寬度 {maxWidth}px',
  'fabric.editor.media.pixelEntry.migrationButtonText': '轉換為像素',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': '從百分比移轉為固定像素大小',
  'fabric.editor.media.pixelEntry.submitButtonText': '提交',
  'fabric.editor.media.pixelEntry.validationFailedMessage': '寬度驗證失敗',
  'fabric.editor.mediaAddLink': '新增連結',
  'fabric.editor.mediaFiles': '圖片、影片或檔案',
  'fabric.editor.mediaFiles.description': '將影像和其他檔案新增至頁面',
  'fabric.editor.mediaGroupDeleteLabel': '刪除',
  'fabric.editor.media_change_mediainline_caption_warn': '內嵌 (標題將會移除)',
  'fabric.editor.media_change_mediainline_default': '內嵌',
  'fabric.editor.media_change_mediasingle': '原始尺寸',
  'fabric.editor.mention': '提及',
  'fabric.editor.mention.description': '提及他人以傳送通知',
  'fabric.editor.mentionNode.label': '已標記使用者',
  'fabric.editor.mentionsAddLabel': '新增圖示',
  'fabric.editor.mentionsIconLabel': '提及',
  'fabric.editor.mergeCells': '合併儲存格',
  'fabric.editor.moreFormatting': '更多格式設定',
  'fabric.editor.moveColumnLeft': '{0, plural, other {將欄向左移動}}',
  'fabric.editor.moveColumnRight': '{0, plural, other {將欄向右移動}}',
  'fabric.editor.moveDownDown': '{0, plural, other {向下移動列}}',
  'fabric.editor.moveRowUp': '{0, plural, other {向上移動列}}',
  'fabric.editor.navigate.toolbar.askAI': '詢問人工智慧',
  'fabric.editor.navigate.toolbar.editor': '導覽至編輯器工具列',
  'fabric.editor.navigate.toolbar.floating': '導覽至浮動工具列',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {您沒有將留言新增至此部落格貼文的權限} page {您沒有將留言新增至此頁面的權限} other {您沒有將留言新增至此頁面的權限}}',
  'fabric.editor.noResultsFound': '沒有結果',
  'fabric.editor.noSearchResults': '沒有搜尋結果',
  'fabric.editor.normal': '一般文字',
  'fabric.editor.note': '附註',
  'fabric.editor.notePanel': '附註面板',
  'fabric.editor.notePanel.description': '以彩色面板新增附註',
  'fabric.editor.numberedColumn': '編號直欄',
  'fabric.editor.off': '{formattingType} 關閉',
  'fabric.editor.on': '{formattingType} 開啟',
  'fabric.editor.openButtonTitle': '開啟',
  'fabric.editor.openCellOptions': '開啟儲存格選項',
  'fabric.editor.openLink': '在新的索引標籤中開啟連結',
  'fabric.editor.openPreviewPanel': '開放預覽看板',
  'fabric.editor.orderedList': '編號清單',
  'fabric.editor.orderedList.description': '建立已排序的清單',
  'fabric.editor.other': '其他...',
  'fabric.editor.outdent': '減少縮排',
  'fabric.editor.overflowMenuViewMore': '檢視更多',
  'fabric.editor.pageActionsLabel': '頁面動作',
  'fabric.editor.panel': '面板',
  'fabric.editor.panel.backgroundColor': '背景顏色',
  'fabric.editor.panel.custom': '自訂',
  'fabric.editor.panel.emoji': '新增表情符號',
  'fabric.editor.panel.panelsGroup': '面板類型',
  'fabric.editor.panelButtonTitle': '面板',
  'fabric.editor.pasteOptions': '貼上選項',
  'fabric.editor.pastePlainText': '貼上純文字',
  'fabric.editor.placeholderAltText': '使用替代文字描述這張圖片',
  'fabric.editor.placeholderText': '預留位置文字',
  'fabric.editor.placeholderText.description': '在頁面中插入文字預留位置',
  'fabric.editor.placeholderTextPlaceholder': '新增預留位置文字',
  'fabric.editor.plainText': '使用純文字',
  'fabric.editor.preferencesLink': '連結喜好設定',
  'fabric.editor.previewButtonTitle': '預覽',
  'fabric.editor.quickInsert': '快速插入',
  'fabric.editor.recordLoomShortTitle': '錄製',
  'fabric.editor.recordVideo': '錄製 Loom 影片',
  'fabric.editor.recordVideo.description': '錄製並分享您的畫面和想法',
  'fabric.editor.redo': '重做',
  'fabric.editor.remove': '移除',
  'fabric.editor.removeColumns': '{0, plural, other {刪除直欄}}',
  'fabric.editor.removeEmoji': '移除表情符號',
  'fabric.editor.removeImageBorder': '移除邊框',
  'fabric.editor.removeRows': '{0, plural, other {刪除列}}',
  'fabric.editor.replace': '取代',
  'fabric.editor.replaceAll': '全部取代',
  'fabric.editor.replaceSuccess': '{numberOfMatches, plural, other {已替換 {numberOfMatches,number} 個相符項目}}',
  'fabric.editor.replaceWith': '取代為',
  'fabric.editor.requestToEdit': '要求編輯',
  'fabric.editor.requestToEditDescription': '您要求權限時，頁面負責人會收到通知。',
  'fabric.editor.requestToEditDismiss': '關閉',
  'fabric.editor.resizeHandle': '重新調整控點大小',
  'fabric.editor.resultsCount': '第 {selectedMatchPosition} 個，共 {totalResultsCount} 個',
  'fabric.editor.richText': '使用 RTF',
  'fabric.editor.rightSidebar': '右側邊欄版面配置',
  'fabric.editor.rowControl': '醒目提示列',
  'fabric.editor.rowDragHandle': '列選項',
  'fabric.editor.rowMovedDown': '列已下移至第 {index} 列，總共有 {total} 列',
  'fabric.editor.rowMovedUp': '列已上移至第 {index} 列，總共有 {total} 列',
  'fabric.editor.rowSelected': '已選取第 {index} 列，總共有 {total} 列',
  'fabric.editor.rowsAreInserted': '{count, plural, other {已插入 {count} 列}}',
  'fabric.editor.rowsAreRemoved': '{count, plural, other {已移除 {count} 列}}',
  'fabric.editor.saveButton': '儲存',
  'fabric.editor.searchResults':
    '{itemsLength, plural, other {有 {itemsLength,number} 個搜尋結果。請使用向上鍵和向下鍵導覽選項。按 Enter 鍵可選取選項。}}',
  'fabric.editor.selectColumnResize': '選取欄重新調整大小',
  'fabric.editor.selectLanguage': '選取語言',
  'fabric.editor.selectTableColumn': '選取表格欄',
  'fabric.editor.selectTableRow': '選取表格列',
  'fabric.editor.selectionExtensionDropdownButtonLabel': '選取應用程式',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': '更多選項',
  'fabric.editor.settingsLinks': '前往連結偏好設定',
  'fabric.editor.shortEmptyNodePlaceholderText': '輸入 / 即可插入內容',
  'fabric.editor.shortcut': '文字快顯',
  'fabric.editor.single': '單一欄版面配置',
  'fabric.editor.singleColumns': '1 欄版面配置',
  'fabric.editor.sortColumnASC': '以 A → Z 排序直欄',
  'fabric.editor.sortColumnDESC': '以 Z → A 排序直欄',
  'fabric.editor.sortColumnDecreasing': '排序遞減',
  'fabric.editor.sortColumnIncreasing': '排序遞增',
  'fabric.editor.splitCell': '分割儲存格',
  'fabric.editor.status': '狀態',
  'fabric.editor.status.description': '新增自訂狀態標籤',
  'fabric.editor.statusEditorLabel': '狀態編輯器',
  'fabric.editor.statusPickerOpenedAlert': '狀態編輯器快顯視窗已開啟，按 Tab 即可前往快顯視窗',
  'fabric.editor.statusPlaceholder': '設定狀態',
  'fabric.editor.story': '故事',
  'fabric.editor.strike': '刪除線',
  'fabric.editor.subTask': '子任務',
  'fabric.editor.subscript': '下標',
  'fabric.editor.subscript.off.superscript.on': '下標關閉，上標開啟',
  'fabric.editor.success': '成功',
  'fabric.editor.successPanel': '成功面板',
  'fabric.editor.successPanel.description': '以彩色面板新增提示',
  'fabric.editor.superscript': '上標',
  'fabric.editor.superscript.off.subscript.on': '上標關閉，下標開啟',
  'fabric.editor.supportAltText': '替代文字對於因為視障而使用螢幕閱讀器的人相當實用。',
  'fabric.editor.table': '表格',
  'fabric.editor.table.description': '插入表格',
  'fabric.editor.tableAlignmentOptions': '對齊選項',
  'fabric.editor.tableFullWidthLabel': '全寬',
  'fabric.editor.tableHeader.sorting.asc': '已套用遞增排序',
  'fabric.editor.tableHeader.sorting.default': '排序直欄',
  'fabric.editor.tableHeader.sorting.desc': '已套用遞減排序',
  'fabric.editor.tableHeader.sorting.invalid': '您無法使用合併的儲存格來排序表格',
  'fabric.editor.tableHeader.sorting.no': '沒有套用至直欄的排序',
  'fabric.editor.tableOptions': '表格選項',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, other {表格寬度已降低至 {newWidth,number} 像素。}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, other {表格寬度已提升至 {newWidth,number} 像素。}}',
  'fabric.editor.tableScrollRegion': '表格捲動區域',
  'fabric.editor.tableSelector': '表格尺寸',
  'fabric.editor.tableSelector.description': '使用彈出視窗新增表格，以選取自訂大小',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} 乘以 {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': '表格大小選取器',
  'fabric.editor.tables.adjustColumn': '調整欄',
  'fabric.editor.tables.columnResizeLast': '您只能重新調整此欄左側的大小。',
  'fabric.editor.tables.columnResizeOverflow': '您只能在表格有捲軸時重新調整此欄的大小。',
  'fabric.editor.tables.columnWidth': '{width, plural, other {欄寬已變更為 {width} 像素}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage': '刪除 {nodeName} 將中斷與其連結的任何內容。',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': '刪除',
  'fabric.editor.tables.resizeStop': '已停止調整大小',
  'fabric.editor.tables.resizeTable': '重新調整表格大小',
  'fabric.editor.tables.startedColumnResize': '已開始調整欄的大小',
  'fabric.editor.task': '任務',
  'fabric.editor.taskDecision.markTaskAsCompleted': '將任務標示為已完成',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': '將任務標示為未完成',
  'fabric.editor.taskList': '任務列表',
  'fabric.editor.taskPlaceholder': '輸入動作，使用「@」以指派給他人。',
  'fabric.editor.text.formatting.off': '文字格式設定關閉',
  'fabric.editor.textColor': '{selectedColorName}的文字顏色',
  'fabric.editor.textColorHighlightTooltip': '文字和醒目提示顏色',
  'fabric.editor.textColorTooltip': '文字顏色',
  'fabric.editor.textFormat': '設定文字格式',
  'fabric.editor.textFormatting': '文字格式設定',
  'fabric.editor.textStyles': '{blockTypeName}的文字樣式',
  'fabric.editor.textStylesTooltip': '文字樣式',
  'fabric.editor.threeColumns': '3 欄版面配置',
  'fabric.editor.threeColumnsWithLeftSidebars': '包含左側邊欄的三欄版面配置',
  'fabric.editor.threeColumnsWithRightSidebars': '包含右側邊欄的三欄版面配置',
  'fabric.editor.threeColumnsWithSidebars': '包含側邊欄的三欄版面配置',
  'fabric.editor.time.ago': '前',
  'fabric.editor.time.updated': '已更新',
  'fabric.editor.time.viewed': '已檢視',
  'fabric.editor.toolbarAppears': '工具列顯示',
  'fabric.editor.toolbarLabel': '編輯器',
  'fabric.editor.toolbarMediaTitle': '新增圖片、影片或檔案',
  'fabric.editor.toolbarPositionFixedAtTop': '固定在頂部',
  'fabric.editor.toolbarPositionInline': '與文字內嵌',
  'fabric.editor.toolbarPositionPinedAtTop': '取消釘選工具列',
  'fabric.editor.toolbarPositionUnpined': '將工具列釘選在頂端',
  'fabric.editor.toolbarPositionUnpinnedConcise': '將工具列固定至頂部',
  'fabric.editor.tooltip.blockPanel': '面板',
  'fabric.editor.tooltip.bulletList': '清單',
  'fabric.editor.tooltip.decisionList': '決定清單',
  'fabric.editor.tooltip.defaultBlockNode': '區塊節點',
  'fabric.editor.tooltip.nestedExpand': '巢狀擴充',
  'fabric.editor.tooltip.taskList': '動作項目',
  'fabric.editor.turnInto': '轉變成',
  'fabric.editor.twoColumns': '2 欄版面配置',
  'fabric.editor.typeAhead.popupLabel': '自動提示結果',
  'fabric.editor.typeAhead.quickInsertInputLabel': '開始輸入以搜尋或篩選快速鍵選項',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': '搜尋',
  'fabric.editor.typeAhead.quickInsertPopupLabel': '插入和格式化的快速鍵',
  'fabric.editor.typeAheadErrorFallbackDescription': '沒有可用的結果。 請再試一次。',
  'fabric.editor.typeAheadErrorFallbackHeading': '發生錯誤',
  'fabric.editor.typeahead.emojiInputLabel': '開始輸入以搜尋或篩選表情符號選項',
  'fabric.editor.typeahead.emojiListItemLabel': '表情符號 {name} 文字快速鍵 {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': '表情符號快速鍵',
  'fabric.editor.typeahead.mentionInputLabel': '開始輸入以搜尋要標記的使用者',
  'fabric.editor.typeahead.mentionPopupLabel': '您可以標記的使用者',
  'fabric.editor.typeahead.metionListItemLabel': '使用者 {name} @{shortName}',
  'fabric.editor.unableToLoadContent': '我們無法載入此內容',
  'fabric.editor.unableToOpenLink': '無法開啟此連結',
  'fabric.editor.underline': '底線',
  'fabric.editor.undo': '復原',
  'fabric.editor.unknown.label': '未知',
  'fabric.editor.unlink': '取消連結',
  'fabric.editor.unorderedList': '項目符號清單',
  'fabric.editor.unorderedList.description': '建立未排序的清單',
  'fabric.editor.unsupportedBlockContent': '此編輯器不支援顯示此內容',
  'fabric.editor.unsupportedContentTooltip': '內容不適用於此編輯器，這會在您編輯和儲存時進行保留',
  'fabric.editor.unsupportedInlineContent': '不支援的內容',
  'fabric.editor.upDown': '在下列輸入欄位中使用向上和向下箭頭按鍵時，日期將在下方更新',
  'fabric.editor.url': '顯示 URL',
  'fabric.editor.urlDescription': '將連結顯示為 URL',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': '使用 Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': '檢視和新增留言',
  'fabric.editor.viewCommentOnMedia': '檢視留言',
  'fabric.editor.viewMore': '檢視更多',
  'fabric.editor.viewMoreAriaLabel': '檢視所有元素',
  'fabric.editor.visit': '在新視窗中開啟連結',
  'fabric.editor.warning': '警告',
  'fabric.editor.warningPanel': '警告面板',
  'fabric.editor.warningPanel.description': '以彩色面板新增注意附註',
  'fabric.editor.wrapLeft': '靠左圍繞',
  'fabric.editor.wrapRight': '靠右圍繞',
  'fabric.emoji.label': '表情符號',
  'fabric.theme.blue': '藍色',
  'fabric.theme.bold-blue': '個性藍',
  'fabric.theme.bold-gray': '個性灰',
  'fabric.theme.bold-green': '個性綠',
  'fabric.theme.bold-magenta': '個性洋紅',
  'fabric.theme.bold-orange': '個性橘',
  'fabric.theme.bold-purple': '個性紫',
  'fabric.theme.bold-red': '個性紅',
  'fabric.theme.bold-teal': '個性藍綠',
  'fabric.theme.bold-yellow': '個性黃',
  'fabric.theme.bolder-blue': '酷炫藍',
  'fabric.theme.bolder-gray': '酷炫灰',
  'fabric.theme.bolder-green': '酷炫綠',
  'fabric.theme.bolder-magenta': '酷炫洋紅',
  'fabric.theme.bolder-orange': '酷炫橘',
  'fabric.theme.bolder-purple': '酷炫紫',
  'fabric.theme.bolder-red': '酷炫紅',
  'fabric.theme.bolder-teal': '酷炫藍綠',
  'fabric.theme.bolder-yellow': '酷炫黃',
  'fabric.theme.dark-blue': '深藍色',
  'fabric.theme.dark-gray': '深灰色',
  'fabric.theme.dark-green': '深綠色',
  'fabric.theme.dark-purple': '深紫色',
  'fabric.theme.dark-red': '深紅色',
  'fabric.theme.dark-teal': '深藍綠色',
  'fabric.theme.dark-yellow': '深黃色',
  'fabric.theme.default': '預設',
  'fabric.theme.gray': '灰色',
  'fabric.theme.green': '綠色',
  'fabric.theme.light-blue': '淺藍色',
  'fabric.theme.light-gray': '淺灰色',
  'fabric.theme.light-green': '淺綠色',
  'fabric.theme.light-purple': '淺紫色',
  'fabric.theme.light-red': '淺紅色',
  'fabric.theme.light-teal': '淺藍綠色',
  'fabric.theme.light-yellow': '淺黃色',
  'fabric.theme.lime': '檸檬黃',
  'fabric.theme.magenta': '洋紅色',
  'fabric.theme.no-color': '沒有醒目提示',
  'fabric.theme.orange': '橘色',
  'fabric.theme.purple': '紫色',
  'fabric.theme.red': '紅色',
  'fabric.theme.subtle-blue': '內斂藍',
  'fabric.theme.subtle-gray': '內斂灰',
  'fabric.theme.subtle-green': '內斂綠',
  'fabric.theme.subtle-magenta': '內斂洋紅',
  'fabric.theme.subtle-orange': '內斂橘',
  'fabric.theme.subtle-purple': '內斂紫',
  'fabric.theme.subtle-red': '內斂紅',
  'fabric.theme.subtle-teal': '內斂藍綠',
  'fabric.theme.subtle-yellow': '內斂黃',
  'fabric.theme.teal': '藍綠色',
  'fabric.theme.white': '白色',
  'fabric.theme.yellow': '黃色',
  'fabrid.editor.rowNumbers': '列數',
  'rovo.agents.dropdown.title': '客服人員',
  'rovo.agents.dropdown.viewAgents.label': '檢視所有客服人員',
};
